import { removeTrailingSlash } from '@/utils/removeTrailingSlash';

export function getImageServer(trailingSlash = true) {
  const imageServer = process.env.OCELOT_LABRADOR_IMAGE_SERVER;
  if (!imageServer) throw new Error('Missing env: OCELOT_LABRADOR_IMAGE_SERVER');
  return removeTrailingSlash(imageServer) + (trailingSlash ? '/' : '');
}
